import React from 'react';
import SeoMetadata from '../components/Seo/SeoMetadata';
import TituloMuroBambooEspejo from '../components/sections/MuroBambooEspejo/TituloMuroBambooEspejo'; 
import IntroMuroBambooEspejo from '../components/sections/MuroBambooEspejo/IntroMuroBambooEspejo'; 
import CaracteristicasMuroBambooEspejo from '../components/sections/MuroBambooEspejo/CaracteristicasMuroBambooEspejo';   
import CatalogoMuroBambooEspejo from '../components/sections/MuroBambooEspejo/CatalogoMuroBambooEspejo';
import FormularioContactoBambooEspejo from '../components/sections/MuroBambooEspejo/FormularioContactoBambooEspejo';
import Header from '../components/layouts/Header'; 
import Footer from '../components/layouts/Footer';

const MuroBambooEspejo = () => {
  return (
    <div>
      <SeoMetadata
        title="Muro Bamboo Espejo | Decototal"
        description="Dale un acabado decorativo a tus espacios con revestimiento bamboo espejo. Explora sus modelos y solicita información para tu proyecto."
        keywords="bamboo espejo, panel bamboo espejo, revestimiento para muro, muro decorativo"
        path="/muro-bamboo-espejo"
        image="/assets/img/home/muro-espejo-bambu.jpg"
      />
      <Header />
        <TituloMuroBambooEspejo />   
        <IntroMuroBambooEspejo />  
        <CaracteristicasMuroBambooEspejo />   
        <CatalogoMuroBambooEspejo />  
        <FormularioContactoBambooEspejo />
      <Footer />
    </div>
  );
};

export default MuroBambooEspejo;